export const message = {
    FETCHING_DETAILS: "Fetching API details...",
    GETTING_APIS: "Getting APIs...",
    GETTING_API_DETAILS: "Getting API details...",
    GETTING_VERSION_DOC: "Getting selected version documentation...",
    GETTING_SELECTED_VERSION: "Getting selected version...",
    GETTING_ORDER_DATA: 'Getting orders data...',
    GETTING_DETAILS: 'Getting details...',
    UPDATING_DETAILS: 'Updating details...',
    DELETING_USER: 'Deleting user...',
    GETTING_PERFORMANCE_REPORT: 'Getting performance report...',
    DOWNLOAD: 'Downloading...',
    PLACE_ORDER: 'Placing order...',
    VALIDATE: 'Validating credentials...',
    INCORRECT_INPUT: "Incorrect credentials. Please try again...",
    GETTING_CHECKOUT_CART: 'Getting checkout cart...',
    GETTING_COMMERCIAL_DETAIL: 'Getting commercial details...',
    SAVING_AGREEMENT: 'Saving commercial agreement...',
    VALIDATE_REFERRAL_COUPON: 'Validating refferal coupon...',
    REMOVING_REFERRAL_COUPON: 'Removing referral coupon...',
    SUBMIT_SIGN_OFF: "Submitting signoff documents...",
    SUBMIT_REQUEST: "Submitting request...",
    GETTING_TICKET_DETAILS: 'Getting ticket details...',
    SENDING: 'Sending...',
    SHARING: 'Sharing...',
    SAVING_LATER: 'Saving for later...',
    ADDING_CHECKOUT: 'Adding to checkout...',
    USER_ACCESS_REMOVED: "User access removed successfully!!!",
    CONFIRM_USER_ACCESS_REMOVED: "Do you want to remove access of this user?",
    SEARCH_RESULT: "Getting search results...",
    LOADING: "Loading items...",
    REMOVING_FROM_CART: "Removing item from the cart...",
    REMOVING_FROM_WISHLIST: 'Removing from wishlist...',
    MOVE_CART: "Moving to cart...",
    FILE_SIZE: "File size must be less than 5MB",
    FILE_TYPE: "Only accepts PDF and Word file types",
    FILE_REQUIRED: "File is required",  
}